import { createGlobalStyle } from 'styled-components';
import Theme from '../Theme/Theme';

const StyledButton = createGlobalStyle`

.ant-btn{
    border-radius: ${Theme.radius['xl']};
    font-family: ${Theme.typography.fontFamily};
    display: inline-flex;
    justify-content: center;
    align-items: center;
    font-size: ${Theme.typography.fontSize.ui_m};
    font-weight:${Theme.typography.weight.medium};
    
    &.ant-btn-black {
        background-color: ${Theme.color['black-1']}!important;
        color: ${Theme.color['white']}!important;
        }
    }

    &.ant-btn-blue {
        background-color: ${Theme.color['blue-4']}!important;
        color: ${Theme.color['white']}!important;

        &:hover{
            background-color: ${Theme.color['blue-5']} !important;
            border-color: transparent !important;
            color: ${Theme.color['white']} !important;
        }
    }

    &.ant-btn-outline {
        color: ${Theme.color['black-1']}!important;
        border: ${Theme.border.sm} solid ${Theme.color['black-1']}!important;

        &:hover{
            color: ${Theme.color['black-1']} !important;
            border: ${Theme.border.sm} solid ${Theme.color['black-1']} !important;
        }
    }

    &.ant-btn-primary {
        background-color: ${Theme.color['blue-4']}!important;
        color: ${Theme.color['white']}!important;
        &:hover{
            background-color: ${Theme.color['blue-5']} !important;
            border-color: transparent !important;
            color: ${Theme.color['white']} !important;
        }
    }



    &.ant-btn-link {
       padding: 0!important;
    }

    .left-icon{
        margin-right:  ${Theme.spacing.s03};
    }

    .right-icon{
        margin-left:  ${Theme.spacing.s03};
    }

    &.-xsmall{
        padding: ${Theme.spacing.s03} ${Theme.spacing.s05};
        font-size: ${Theme.typography.fontSize.ui_xs};

        .left-icon{
            margin-right:  ${Theme.spacing.s02};
        }
    
        .right-icon{
            margin-left:  ${Theme.spacing.s02};
        }

    }
    &.-small{
        padding: ${Theme.spacing.s04} ${Theme.spacing.s06};
        font-size: ${Theme.typography.fontSize.ui_s};
    }
    &.-medium{
        padding: ${Theme.spacing.s05} ${Theme.spacing.s07};
        font-size: ${Theme.typography.fontSize.ui_m};
    }
    &.-large{
        padding: ${Theme.spacing.s06} ${Theme.spacing.s08};
        font-size: ${Theme.typography.fontSize.iu_l};
    }

    &.ant-btn-black:disabled,
    &.ant-btn-blue:disabled,
    &.ant-btn-outline:disabled,
    &.ant-btn-link:disabled{
        background-color: ${Theme.color['coolgray-2']} !important;
        border-color: transparent !important;
        color: ${Theme.color['white']} !important;
        pointer-events: none;
    }
`;
export default StyledButton;